module.exports = __webpack_public_path__ + "img/case-worm-onload.4ef2c952.png";